// extracted by mini-css-extract-plugin
export default {"loading":"LoaderIcon_loading__wn452","spin":"LoaderIcon_spin__EBsrx"};